/// <amd-module name="Dashboards/WidgetContracts/Internal/WidgetMetadataProps" />
/** Describe server-generated properties of a widget, which are used internally by WidgetHost. */
export interface WidgetMetadataProps {
    configurationContributionId: string;

    areSettingsBlockedForUser: boolean;

    /** Indicates if name is configurable for this kind of Widget.
     *  WidgetHost uses this to determine if configuration UI should be visible. */
    isNameConfigurable: boolean;

    isEnabled: boolean;
}
